module.exports = __webpack_public_path__ + "img/about-qua1.bced6b3e.png";